import { css } from '@emotion/core';
import { MediaQueries } from '../../../../../styles/Grid';
import { ColumnPadding } from '../../../../../styles/Grid/GridSizes';
import { colorsPalette } from '../../../../../styles/colors';
import { fontWeights } from '../../../../../styles/typography';

export const form = css({
  width: '100%',
  paddingBottom: 70,
  [MediaQueries.lgAndUp]: {
    minHeight: 400,
  },
});

export const checkboxContainer = css({
  padding: `0 ${ColumnPadding.sm}px`,
  [MediaQueries.mdAndUp]: {
    padding: `0 ${ColumnPadding.md}px`,
  },
  [MediaQueries.lgAndUp]: {
    display: 'flex',
    padding: 0,
  },
  strong: {
    fontWeight: fontWeights.medium,
  },
});

export const checkboxWrapper = css({
  position: 'relative',
  marginBottom: 16,
  [MediaQueries.lgAndUp]: {
    display: 'flex',
    flex: '1 1',
    margin: `0 ${ColumnPadding.lg}px`,
  },
});

export const checkbox = css({
  marginBottom: 0,
  width: '100%',
});

export const labelChecked = css({
  '&, &:hover': {
    boxShadow: `
      0 10px 80px rgba(0, 0, 0, 0.08),
      0 140px 80px rgba(0, 0, 0, 0.08),
      0 260px 80px rgba(0, 0, 0, 0.08)
    `,
    [MediaQueries.xl]: {
      boxShadow: `
      0 10px 80px rgba(0, 0, 0, 0.08),
      0 140px 80px rgba(0, 0, 0, 0.08),
      0 200px 80px rgba(0, 0, 0, 0.08)
    `,
    },
  },
});

export const numbersContainer = css({
  borderTop: `1px solid ${colorsPalette.grey10}`,
  position: 'relative',
  backgroundColor: 'white',
  zIndex: 1,
  padding: 16,
  [MediaQueries.mdAndUp]: {
    display: 'flex',
  },
  [MediaQueries.lgAndUp]: {
    display: 'block',
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0,
    transform: 'translateY(100%)',
    padding: 24,
  },
});

export const numberPickerContainer = css({
  [MediaQueries.mdAndUp]: {
    flex: '1 1 50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  [MediaQueries.xl]: {
    flexDirection: 'row',
  },
});

export const firstNumberPicker = css(numberPickerContainer, {
  marginBottom: 24,
  [MediaQueries.mdAndUp]: {
    marginBottom: 0,
    marginRight: 32,
  },
  [MediaQueries.lgAndUp]: {
    marginRight: 0,
    marginBottom: 24,
  },
  [MediaQueries.xl]: {
    marginBottom: 16,
  },
});

export const numberPickerLabel = css({
  [MediaQueries.xl]: {
    flex: '1 1 50%',
    marginRight: 32,
    marginBottom: 0,
    display: 'flex',
    alignItems: 'center',
  },
});

export const numberPickerControls = css({
  [MediaQueries.xl]: {
    flex: '1 1 50%',
  },
});
